// extracted by mini-css-extract-plugin
export default {"leftShadow":"h-scrollbars-w-shadow_leftShadow__r27NM","rightShadow":"h-scrollbars-w-shadow_rightShadow__ddp+8","placeHolderShimmer":"h-scrollbars-w-shadow_placeHolderShimmer__FaKzA"};